import { MarketCode } from '@tink/config/src/markets';
import { AnalyticsProduct } from '@tink/tink-link-core/src/analytics-product';
import { UserFlow } from '@tink/tink-link-core/src/analytics-user-flow';

export enum PageView {
  ERROR_SCREEN = 'ERROR_SCREEN',
  SUCCESS_SCREEN = 'SUCCESS_SCREEN',
  NO_ACCOUNTS_SCREEN = 'NO_ACCOUNTS_SCREEN',
  PAYMENT_FAILURE_SCREEN = 'PAYMENT_FAILURE_SCREEN',
  ACCOUNT_SELECTION_SCREEN = 'ACCOUNT_SELECTION_SCREEN',
  ACCOUNT_SELECTION_SCREEN_SINGLE = 'ACCOUNT_SELECTION_SCREEN_SINGLE',
  ACCOUNT_SELECTION_SCREEN_MULTIPLE = 'ACCOUNT_SELECTION_SCREEN_MULTIPLE',
  SUBMIT_CREDENTIALS_SCREEN = 'SUBMIT_CREDENTIALS_SCREEN',
  SPARKASSE_SUBMIT_CREDENTIALS_SCREEN = 'SPARKASSE_SUBMIT_CREDENTIALS_SCREEN',
  SUBMIT_CREDENTIALS_SCREEN_BANKID = 'SUBMIT_CREDENTIALS_SCREEN_BANKID',
  SUBMIT_HANDOFF_CREDENTIALS_SCREEN = 'SUBMIT_HANDOFF_CREDENTIALS_SCREEN',
  HANDOFF_QR_CODE_SCREEN = 'HANDOFF_QR_CODE_SCREEN',
  HANDOFF_COMPLETED_RESULT_SCREEN = 'HANDOFF_COMPLETED_RESULT_SCREEN',
  HANDOFF_MOBILE_OPEN_APP_SCREEN = 'HANDOFF_MOBILE_OPEN_APP_SCREEN',
  HANDOFF_PAY_ERROR_SCREEN = 'HANDOFF_PAY_ERROR_SCREEN',
  INSUFFICIENT_FUNDS_ERROR_SCREEN = 'INSUFFICIENT_FUNDS_ERROR_SCREEN',
  DUPLICATED_PAYMENT_ERROR_SCREEN = 'DUPLICATED_PAYMENT_ERROR_SCREEN',
  SWEDBANK_SAVINGSBANK_ERROR_SCREEN = 'SWEDBANK_SAVINGSBANK_ERROR_SCREEN',
  PAYMENT_CANCELLED_SCREEN = 'PAYMENT_CANCELLED_SCREEN',
  ACCESS_TYPE_SELECTION_SCREEN = 'ACCESS_TYPE_SELECTION_SCREEN',
  BANKID_LOCAL_AWAITING_SCREEN = 'BANKID_LOCAL_AWAITING_SCREEN',
  BANKID_REMOTE_AWAITING_SCREEN = 'BANKID_REMOTE_AWAITING_SCREEN',
  BANKID_TARGET_AWAITING_SCREEN = 'BANKID_TARGET_AWAITING_SCREEN',
  BANKID_HANDOFF_SCREEN = 'BANKID_HANDOFF_SCREEN',
  SUPPLEMENTAL_INFORMATION_SCREEN = 'SUPPLEMENTAL_INFORMATION_SCREEN',
  SUPPLEMENTAL_CHECKBOX_SCREEN = 'SUPPLEMENTAL_CHECKBOX_SCREEN',
  CONSENT_SCREEN = 'CONSENT_SCREEN',
  PAY_MERCHANT_CONSENT_SCREEN = 'PAY_MERCHANT_CONSENT_SCREEN',
  NETFLIX_CONSENT_SCREEN = 'NETFLIX_CONSENT_SCREEN',
  LOGIN_TEMPLATE_SCREEN = 'LOGIN_TEMPLATE_SCREEN',
  LEGACY_SUBMIT_CREDENTIALS_SCREEN = 'LEGACY_SUBMIT_CREDENTIALS_SCREEN',
  NO_FIELDS_FORM_SCREEN = 'NO_FIELDS_FORM_SCREEN',
  PROVIDER_SELECTION_SCREEN = 'PROVIDER_SELECTION_SCREEN',
  PROVIDER_GROUP_SELECTION_SCREEN = 'PROVIDER_GROUP_SELECTION_SCREEN',
  PROVIDER_FINANCIAL_SELECTION_SCREEN = 'PROVIDER_FINANCIAL_SELECTION_SCREEN',
  PROVIDER_SEGMENT_SELECTION_SCREEN = 'PROVIDER_SEGMENT_SELECTION_SCREEN',
  PROVIDER_AUTHENTICATION_SELECTION_SCREEN = 'PROVIDER_AUTHENTICATION_SELECTION_SCREEN',
  PROVIDER_ACCESS_SELECTION_SCREEN = 'PROVIDER_ACCESS_SELECTION_SCREEN',
  PROVIDER_CREDENTIALS_SELECTION_SCREEN = 'PROVIDER_CREDENTIALS_SELECTION_SCREEN',
  PROVIDER_DESCRIPTION_SELECTION_SCREEN = 'PROVIDER_DESCRIPTION_SELECTION_SCREEN',
  PROVIDER_DEMOBANK_SELECTION_SCREEN = 'PROVIDER_DEMOBANK_SELECTION_SCREEN',
  REFRESH_USER_CREDENTIALS_SCREEN = 'REFRESH_USER_CREDENTIALS_SCREEN',
  CREDENTIALS_TYPE_SELECTION_SCREEN = 'CREDENTIALS_TYPE_SELECTION_SCREEN',
  DISPLAY_DESCRIPTION_SELECTION_SCREEN = 'DISPLAY_DESCRIPTION_SELECTION_SCREEN',
  AUTHENTICATION_TYPE_SELECTION_SCREEN = 'AUTHENTICATION_TYPE_SELECTION_SCREEN',
  AUTHENTICATE_USER_CREDENTIALS_SCREEN = 'AUTHENTICATE_USER_CREDENTIALS_SCREEN',
  AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN = 'AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN',
  SUBMIT_HANDOFF_CREDENTIALS_PAY_SCREEN = 'SUBMIT_HANDOFF_CREDENTIALS_PAY_SCREEN',
  HANDOFF_PAY_MOBILE_OPEN_APP_SCREEN = 'HANDOFF_PAY_MOBILE_OPEN_APP_SCREEN',
  UPDATE_TRANSACTIONS_CONSENT_SCREEN = 'UPDATE_TRANSACTIONS_CONSENT_SCREEN',
  SCOPES_DETAIL_SCREEN = 'SCOPES_DETAIL_SCREEN',
  TERMS_AND_CONDITION_SCREEN = 'TERMS_AND_CONDITION_SCREEN',
  PRIVACY_POLICY_SCREEN = 'PRIVACY_POLICY_SCREEN',
  EXIT_FEEDBACK_SCREEN = 'EXIT_FEEDBACK_SCREEN',
  EXTEND_BANKID_SCREEN = 'EXTEND_BANKID_SCREEN',
  FINANCIAL_SERVICE_PICKER_SCREEN = 'FINANCIAL_SERVICE_PICKER_SCREEN',
  APP_CODE_TEMPLATE_SCREEN = 'APP_CODE_TEMPLATE_SCREEN',
  CARD_READER_TEMPLATE_SCREEN = 'CARD_READER_TEMPLATE_SCREEN',
  REDIRECT_THIRD_PARTY_SCREEN = 'REDIRECT_THIRD_PARTY_SCREEN',
  REDIRECT_HANDLER_AUTH_SCREEN = 'REDIRECT_HANDLER_AUTH_SCREEN',
  REDIRECT_HANDLER_PAY_SCREEN = 'REDIRECT_HANDLER_PAY_SCREEN',
  SMS_CODE_TEMPLATE_SCREEN = 'SMS_CODE_TEMPLATE_SCREEN',
  CHIP_TAN_TEMPLATE_SCREEN = 'CHIP_TAN_TEMPLATE_SCREEN',
  DECOUPLED_TEMPLATE_SCREEN = 'DECOUPLED_TEMPLATE_SCREEN',
  INSTRUCTION_TEMPLATE_SCREEN = 'INSTRUCTION_TEMPLATE_SCREEN',
  MULTIPLE_FIELDS_TEMPLATE_SCREEN = 'MULTIPLE_FIELDS_TEMPLATE_SCREEN',
  SINGLE_SELECTABLE_OPTION_TEMPLATE_SCREEN = 'SINGLE_SELECTABLE_OPTION_TEMPLATE_SCREEN',
  SINGLE_SELECTABLE_IMAGE_TEMPLATE_SCREEN = 'SINGLE_SELECTABLE_IMAGE_TEMPLATE_SCREEN',
  MULTI_SELECTABLE_IMAGE_TEMPLATE_SCREEN = 'MULTI_SELECTABLE_IMAGE_TEMPLATE_SCREEN',
  UNKNOWN_TEMPLATE_SCREEN = 'UNKNOWN_TEMPLATE_SCREEN',
  REDIRECT_HANDLER_SCREEN = 'REDIRECT_HANDLER_SCREEN',
  PAYMENT_PERMANENT_SESSION_CONSENT_SCREEN = 'PAYMENT_PERMANENT_SESSION_CONSENT_SCREEN',
  ANDROID_QR_INSTRUCTIONS_MODAL_SCREEN = 'ANDROID_QR_INSTRUCTIONS_MODAL_SCREEN',
  HANDOFF_QR_CODE_SCANNED_SCREEN = 'HANDOFF_QR_CODE_SCANNED_SCREEN',
  PROVIDER_TEMPORARY_DISABLED_SCREEN = 'PROVIDER_TEMPORARY_DISABLED_SCREEN',
  PROVIDER_HEALTH_STATUS_SCREEN = 'PROVIDER_HEALTH_STATUS_SCREEN',
  FTS_WIDGET_SCREEN = 'FTS_WIDGET_SCREEN',
  NO_SCREEN = 'NO_SCREEN',
  ANIMATED_QR_CODE_SCREEN = 'ANIMATED_QR_CODE_SCREEN',
  HANDOFF_PAY_INSTRUCTIONS_SCREEN = 'HANDOFF_PAY_INSTRUCTIONS_SCREEN',
  PARTIAL_SUCCESS_SCREEN = 'PARTIAL_SUCCESS_SCREEN',
  BULK_PAYMENT_DETAILS_SCREEN = 'BULK_PAYMENT_DETAILS_SCREEN',
  BULK_PAYMENT_FAILED_TRANSFERS_SCREEN = 'BULK_PAYMENT_FAILED_TRANSFERS_SCREEN',
  EXTEND_CONSENT_SCREEN = 'EXTEND_CONSENT_SCREEN',
  OPEN_THIRD_PARTY_REDIRECT_SCREEN = 'OPEN_THIRD_PARTY_REDIRECT_SCREEN',
  THIRD_PARTY_REDIRECT_PENDING_SCREEN = 'THIRD_PARTY_REDIRECT_PENDING_SCREEN',
  THIRD_PARTY_REDIRECT_INSTRUCTIONS_SCREEN = 'THIRD_PARTY_REDIRECT_INSTRUCTIONS_SCREEN',
  THIRD_PARTY_REDIRECT_SCREEN = 'THIRD_PARTY_REDIRECT_SCREEN',
  PAYMENTS_SUMMARY_SCREEN = 'PAYMENTS_SUMMARY_SCREEN',
  PAYMENTS_CONSENT_SCREEN = 'PAYMENTS_CONSENT_SCREEN',
  PAYMENT_MODAL_OVERLAY = 'PAYMENT_MODAL_OVERLAY',
  CREDENTIALS_UPDATING_LOADING_SCREEN = 'CREDENTIALS_UPDATING_LOADING_SCREEN',
  QR_CODE_TEMPLATE_SCREEN = 'QR_CODE_TEMPLATE_SCREEN',
  OTP_METHODS_TEMPLATE_SCREEN = 'OTP_METHODS_TEMPLATE_SCREEN',
  FRAUD_PREVENTION_SCREEN = 'FRAUD_PREVENTION_SCREEN',
  VERIFICATION_TEMPLATE_SCREEN = 'VERIFICATION_TEMPLATE_SCREEN',
  LEGAL_TEMPLATE_SCREEN = 'LEGAL_TEMPLATE_SCREEN',
  NOT_FOUND_SCREEN = 'NOT_FOUND_SCREEN',
  PROVIDER_REDIRECT_INSTRUCTIONS_SCREEN = 'PROVIDER_REDIRECT_INSTRUCTIONS_SCREEN',
  IMAGE_CODE_TEMPLATE_SCREEN = 'IMAGE_CODE_TEMPLATE_SCREEN',
  DEMOBANK_SCENARIO_PICKER_SCREEN = 'DEMOBANK_SCENARIO_PICKER_SCREEN',
  PROVIDER_REGION_PICKER_SCREEN = 'PROVIDER_REGION_PICKER_SCREEN',
  BULK_PAYMENT_FAILURE_SCREEN = 'BULK_PAYMENT_FAILURE_SCREEN',
  FLOW_FINISHED_SCREEN = 'FLOW_FINISHED_SCREEN',
  KYC_LOCAL_SCREEN = 'KYC_LOCAL_SCREEN',
  KYC_REMOTE_SCREEN = 'KYC_REMOTE_SCREEN',
  KYC_AWAITING_SCREEN = 'KYC_AWAITING_SCREEN',
  KYC_ERROR_SCREEN = 'KYC_ERROR_SCREEN',
}

export enum UserInteractionEvent {
  BACK_BUTTON = 'BACK_BUTTON',
  CLOSE_BUTTON = 'CLOSE_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  SUBMIT_CREDENTIALS = 'SUBMIT_CREDENTIALS',
  SUBMIT_CONSENT = 'SUBMIT_CONSENT',
  SUBMIT_SUPPLEMENTAL_INFORMATION = 'SUBMIT_SUPPLEMENTAL_INFORMATION',
  LIST_ITEM = 'LIST_ITEM',
  INPUT_CHANGE = 'INPUT_CHANGE',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  HANDOFF_CANCELLED = 'HANDOFF_CANCELLED',
  HANDOFF_FORCE_DESKTOP_FLOW = 'HANDOFF_FORCE_DESKTOP_FLOW',
  OPEN_BANKID = 'OPEN_BANKID',
  TOGGLE_ACCORDION = 'TOGGLE_ACCORDION',
}

export enum ApplicationEvent {
  /*
   * Tink Link fetched all its resources and is ready for user interaction.
   * User has not selected provider on client side.
   */
  INITIALIZED_WITHOUT_PROVIDER = 'INITIALIZED_WITHOUT_PROVIDER',

  /*
   * Tink Link fetched all its resources and is ready for user interaction.
   * User has selected provider on client side.
   */
  INITIALIZED_WITH_PROVIDER = 'INITIALIZED_WITH_PROVIDER',

  /*
   * Tink Link fetched all its resources and is ready for user interaction.
   * User has an existing consent.
   */
  INITIALIZED_WITH_CONSENT = 'INITIALIZED_WITH_CONSENT',

  /*
   * Only relevant for Reverse engineered provider.
   * User entered credentials and submitted credentials form.
   */
  CREDENTIALS_SUBMITTED = 'CREDENTIALS_SUBMITTED',

  /*
   * Used when some SE provider are authenticating on the same device.
   * This is the default option if we do NOT pass SE_MOBILE_BANKID_OTHER_DEVICE
   * We are NOT actively passing SE_MOBILE_BANKID_SAME_DEVICE to BE
   */
  AUTH_OPTIONS_SAME_DEVICE = 'AUTH_OPTIONS_SAME_DEVICE',

  /*
   * Used when some SE provider are authenticating on other device/AnimatedQR code.
   */
  AUTH_OPTIONS_OTHER_DEVICE = 'AUTH_OPTIONS_OTHER_DEVICE',

  /*
   * Only relevant for Open banking provider.
   * User submitted credentials form and is being redirected to TPP to authenticate.
   */
  PROVIDER_AUTHENTICATION_INITIALIZED = 'PROVIDER_AUTHENTICATION_INITIALIZED',

  /*
   * Only relevant for Reverse engineered provider.
   * Credentials user entered were invalid, user is prompted to try again.
   */
  CREDENTIALS_VALIDATION_FAILED = 'CREDENTIALS_VALIDATION_FAILED',

  /*
   * Credentials object changed its state into `UPDATING`.
   */
  AUTHENTICATION_SUCCESSFUL = 'AUTHENTICATION_SUCCESSFUL',

  /*
   * Transfer status is SENT
   */
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',

  /*
   * Bulk status is SENT
   */
  BULK_PAYMENT_SUCCESSFUL = 'BULK_PAYMENT_SUCCESSFUL',

  /*
   * KYC is DONE and FAILED
   */
  KYC_SUCCESSFUL = 'KYC_SUCCESSFUL',
  KYC_FAILED = 'KYC_FAILED',

  /*
   * Redirect link id passed to postNotificationHandler
   */
  REDIRECT_ATTEMPT = 'REDIRECT_ATTEMPT',

  /*
   * Automatic redirect failed
   */
  REDIRECT_FAILED = 'REDIRECT_FAILED',

  /*
   * Handling stale credentials
   */
  REDIRECT_HANDLER_RESUMED_FLOW = 'REDIRECT_HANDLER_RESUMED_FLOW',

  /*
   * Setting window.location.href
   */
  REDIRECT_BY_SETTING_LOCATION = 'REDIRECT_BY_SETTING_LOCATION',

  /**
   * Permanent users payment initialized
   */
  PAYMENT_PERMANENT_INITIALIZED = 'PAYMENT_PERMANENT_INITIALIZED',
  /**
   * 1SCA-Perm user flow started with credentials in awaiting status, this triggers error credentials in invalid state
   */
  PAYMENT_PERM_INITIALIZED_W_INVALID_STATE_CREDENTIALS = 'PAYMENT_PERMANENT_INITIALIZED_W_INVALID_STATE_CREDENTIALS',

  /**
   * The user has read the legal disclaimer footer
   * (either on the PROVIDER_SELECTION_SCREEN or the SUBMIT_CREDENTIALS_SCREEN)
   */
  LEGAL_DISCLAIMER_READ = 'LEGAL_DISCLAIMER_READ',

  /**
   * The app is using our license (no hidden terms flags in configuration)
   */
  IS_OUR_LICENSE = 'IS_OUR_LICENSE',

  /**
   * PAYMENT STARTED WITH SOURCE ACCOUNT AND 1SCA
   */
  PAYMENT_1SCA_SA = 'PAYMENT_1SCA_SA',
  /**
   * PAYMENT STARTED WITH 1SCA 90 DAYS CONSENT PERM USER
   */
  PAYMENT_1SCA_PERM = 'PAYMENT_1SCA_PERM',
  /**
   * PAYMENT STARTED WITH 2SCA PERM USER (1SCA feature flag)
   */
  PAYMENT_2SCA_PERM = 'PAYMENT_2SCA_PERM',

  /**
   * Started Bulk Payment process
   */
  BULK_PAYMENT_INITIALIZED = 'BULK_PAYMENT_INITIALIZED',

  /**
   * Started Direct Payment execution
   */
  DIRECT_PAYMENT_INITIALIZED = 'DIRECT_PAYMENT_INITIALIZED',

  /**
   * Used by DecoupledTemplateScreen when the supplemental info contains no
   * change method template field.
   */
  DECOUPLED_AUTO_SUBMIT = 'DECOUPLED_AUTO_SUBMIT',

  /**
   * Used by QrCodeTemplateScreen when the supplementary info contains no
   * change method template field.
   */
  QR_CODE_AUTO_SUBMIT = 'QR_CODE_AUTO_SUBMIT',

  /**
   * Used by DecoupledTemplateScreen when the user triggers the submit via a button
   */
  DECOUPLED_USER_SUBMIT = 'DECOUPLED_USER_SUBMIT',

  /**
   * Used by QrCodeTemplateScreen when the user triggers the submit via a button
   */
  QR_CODE_USER_SUBMIT = 'QR_CODE_USER_SUBMIT',

  /**
   * Used by DecoupledTemplateScreen when the user triggers change auth method by clicking a button
   */
  TEMPLATE_CHANGE_METHOD = 'TEMPLATE_CHANGE_METHOD',

  /**
   * Used when the MULTIPLE_FIELDS template is possible to submit
   */
  MULTIPLE_FIELDS_SUBMIT_BUTTON_ENABLED = 'MULTIPLE_FIELDS_SUBMIT_BUTTON_ENABLED',

  /**
   * Used when the MULTIPLE_FIELDS template is NOT possible to submit
   */
  MULTIPLE_FIELDS_SUBMIT_BUTTON_DISABLED = 'MULTIPLE_FIELDS_SUBMIT_BUTTON_DISABLED',

  /**
   * Used when resetting handoff and transfer stores in payment handoff flow
   */
  PAY_RESET_HANDOFF = 'PAY_RESET_HANDOFF',
  PAYMENTS_DECISION_MACHINE = 'PAYMENTS_DECISION_MACHINE',
  PAYMENTS_DECISION_MACHINE_ERROR = 'PAYMENTS_DECISION_MACHINE_ERROR',
  PAYMENTS_AIS_MACHINE = 'PAYMENTS_AIS_MACHINE',
  PAYMENTS_AIS_MACHINE_ERROR = 'PAYMENTS_AIS_MACHINE_ERROR',
  PAYMENTS_AIS_SESSION_MACHINE = 'PAYMENTS_AIS_SESSION_MACHINE',
  PAYMENTS_AIS_SESSION_MACHINE_ERROR = 'PAYMENTS_AIS_SESSION_MACHINE_ERROR',
  PAYMENTS_PIS_MACHINE = 'PAYMENTS_PIS_MACHINE',
  PAYMENTS_PIS_MACHINE_ERROR = 'PAYMENTS_PIS_MACHINE_ERROR',
  PAYMENTS_AUTO_PIS_MACHINE = 'PAYMENTS_AUTO_PIS_MACHINE',
  PAYMENTS_AUTO_PIS_MACHINE_ERROR = 'PAYMENTS_AUTO_PIS_MACHINE_ERROR',
  PAYMENTS_MONITOR_MACHINE = 'PAYMENTS_MONITOR_MACHINE',
  PAYMENTS_MONITOR_MACHINE_ERROR = 'PAYMENTS_MONITOR_MACHINE_ERROR',
  PAYMENTS_AC_BUNDLE_MACHINE = 'PAYMENTS_AC_BUNDLE_MACHINE',
  PAYMENTS_BULK_DECISION_MACHINE = 'PAYMENTS_BULK_DECISION_MACHINE',
  PAYMENTS_BULK_DECISION_MACHINE_ERROR = 'PAYMENTS_BULK_DECISION_MACHINE_ERROR',
  PAYMENTS_BULK_AIS_MACHINE = 'PAYMENTS_BULK_AIS_MACHINE',
  PAYMENTS_BULK_AIS_MACHINE_ERROR = 'PAYMENTS_BULK_AIS_MACHINE_ERROR',
  PAYMENTS_BULK_AIS_SESSION_MACHINE = 'PAYMENTS_BULK_AIS_SESSION_MACHINE',
  PAYMENTS_BULK_AIS_SESSION_MACHINE_ERROR = 'PAYMENTS_BULK_AIS_SESSION_MACHINE_ERROR',
  PAYMENTS_BULK_PIS_MACHINE = 'PAYMENTS_BULK_PIS_MACHINE',
  PAYMENTS_BULK_PIS_MACHINE_ERROR = 'PAYMENTS_BULK_PIS_MACHINE_ERROR',
  PAYMENTS_BULK_AUTO_PIS_MACHINE = 'PAYMENTS_BULK_AUTO_PIS_MACHINE',
  PAYMENTS_BULK_AUTO_PIS_MACHINE_ERROR = 'PAYMENTS_BULK_AUTO_PIS_MACHINE_ERROR',
  PAYMENTS_BULK_MONITOR_MACHINE = 'PAYMENTS_BULK_MONITOR_MACHINE',
  PAYMENTS_BULK_MONITOR_MACHINE_ERROR = 'PAYMENTS_BULK_MONITOR_MACHINE_ERROR',
  PAYMENTS_FTS_MACHINE = 'PAYMENTS_FTS_MACHINE',
  PAYMENTS_FTS_MACHINE_ERROR = 'PAYMENTS_FTS_MACHINE_ERROR',
  THIRD_PARTY_REDIRECT_MACHINE = 'THIRD_PARTY_REDIRECT_MACHINE',
  THIRD_PARTY_REDIRECT_MACHINE_ERROR = 'THIRD_PARTY_REDIRECT_MACHINE_ERROR',
  BANK_ID_MACHINE = 'BANK_ID_MACHINE',
  BANK_ID_MACHINE_ERROR = 'BANK_ID_MACHINE_ERROR',
  HANDOFF_CREATOR_MACHINE = 'HANDOFF_CREATOR_MACHINE',
  HANDOFF_CREATOR_MACHINE_ERROR = 'HANDOFF_CREATOR_MACHINE_ERROR',
  THIRD_PARTY_REDIRECT_HANDLER_MACHINE = 'THIRD_PARTY_REDIRECT_HANDLER_MACHINE',
  THIRD_PARTY_REDIRECT_HANDLER_MACHINE_ERROR = 'THIRD_PARTY_REDIRECT_HANDLER_MACHINE_ERROR',
  CREDENTIALS_MACHINE = 'CREDENTIALS_MACHINE',
  CREDENTIALS_MACHINE_ERROR = 'CREDENTIALS_MACHINE_ERROR',
  CREDENTIALS_CREATOR_MACHINE = 'CREDENTIALS_CREATOR_MACHINE',
  CREDENTIALS_CREATOR_MACHINE_ERROR = 'CREDENTIALS_CREATOR_MACHINE_ERROR',
  REDIRECT_EXECUTOR = 'REDIRECT_EXECUTOR',
  BANKID_KYC_MACHINE = 'BANKID_KYC_MACHINE',
  BANKID_KYC_MACHINE_ERROR = 'BANKID_KYC_MACHINE_ERROR',
  FAILED_TO_MATCH_ACCOUNTS = 'FAILED_TO_MATCH_ACCOUNTS',
}

export enum AnalyticsEventType {
  VIEW_EVENT = 'VIEW_EVENT',
  INTERACTION_EVENT = 'INTERACTION_EVENT',
  APPLICATION_EVENT = 'APPLICATION_EVENT',
}

export type BaseAnalyticsData = {
  /* The session_id of the journey */
  clientId: string;
  sessionId: string;
  credentialsId?: string;
  consentId?: string;
  version: string;
  product: AnalyticsProduct;
  products: AnalyticsProduct[];
  platform: string;
  device: string;
  deviceVendor?: string;
  deviceOs?: string;
  deviceOsVersion?: string;
  deviceModel?: string;
  browserName?: string;
  browserVersion?: string;
  providerName?: string;
  paymentRequestId?: string;
  hasAppUri: boolean;
  isIframe: boolean;
  isWebView: boolean;
};

export type AdditionalAnalyticsData = {
  market?: MarketCode;
  userId?: string;
  providerName?: string;
  credentialsId?: string;
  sessionId?: string;
  merchantId?: string;
  /* Granular identifier of the particular flow we are running */
  flow?: UserFlow;
  sessionSourceAccountSupplied?: boolean;
  errorReason?: string;
};

export type DynamicAnalyticsData = {
  timestamp: string;
};

export type InteractionEvent = {
  view: PageView;
  /* Format should be view/Element */
  action: string;
  /* Granular info about the action, e.g. if the action is “searched_provider”, the label could be the inputted search text */
  label?: string;
};

export type ViewEvent = {
  /* Unique identifier for the screen */
  view: PageView;
};

export type ApplicationEventPayload = {
  type: ApplicationEvent;
};

export type AnalyticsEvent = InteractionEvent | ViewEvent | ApplicationEventPayload;

export type AnalyticsEventData = BaseAnalyticsData &
  AdditionalAnalyticsData &
  AnalyticsEvent &
  DynamicAnalyticsData;

export type AnalyticsData = {
  version: string;
  product: AnalyticsProduct | undefined;
  products: AnalyticsProduct[] | undefined;
  flow: UserFlow;
  market: MarketCode;
  sessionId: string;
  clientId: string | null;
  userId: string | undefined;
  credentialsId: string | undefined;
  paymentRequestId: string | undefined;
  providerName: string | undefined;
  sessionSourceAccountSupplied: boolean;
  hasAppUri: boolean;
  isIframe: boolean;
  timestamp: string;
  platform: string;
  // user device data
  device: string;
  deviceVendor: string;
  deviceOs: string;
  deviceOsVersion: string;
  deviceModel: string;
  browserName: string;
  browserVersion: string;
};

export type NewAnalyticsData = AnalyticsEvent & AnalyticsData;
